/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import {
  FloorChildrenFragmentDoc,
  FloorFragmentDoc
} from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateFloorInput = {
  id: string
  label?: string | null
  position?: number | null
  remark?: string | null
}

export type JsonapiRelationshipData = {
  id: string
  type: string
}

export type UpdateFloorInput = {
  id: string
  label?: string | null
  parent?: JsonapiRelationshipData | null
  position?: number | null
  remark?: string | null
}

export type CreateFloorMutationVariables = Exact<{
  input: Types.CreateFloorInput
  parentType: string
  parentID: string
}>

export type CreateFloorMutation = {
  __typename: "Mutation"
  floor: {
    __typename: "Floor"
    id: string
    label?: string | null
    position: number
    createdAt: string
    updatedAt: string
    remark?: string | null
    hasClarificationRequest?: boolean | null
    children?: Array<{
      __typename: "Room"
      id: string
      label?: string | null
      number: string
      area?: number | null
      volume?: number | null
      utilization?: string | null
      height?: number | null
      personsNumber?: number | null
      airVolumePerArea?: number | null
      airVolumePerPerson?: number | null
      remark?: string | null
      sup?: number | null
      oda?: number | null
      eta?: number | null
      eha?: number | null
      tra?: number | null
      rca?: number | null
      ida?: number | null
      sec?: number | null
      soundPressureLevel?: number | null
      position: number
      createdAt: string
      updatedAt: string
      hasClarificationRequest?: boolean | null
      children?: Array<{
        __typename: "ProductPosition"
        id: string
        label?: string | null
        variantKey: string
        configurationKey?: string | null
        remark?: string | null
        quantity: number
        position: number
        displayPosition?: string | null
        isAlternative?: boolean | null
        price?: number | null
        priceGroup?: string | null
        hasClarificationRequest?: boolean | null
        references?: Array<{
          __typename: "ProductPositionInstallationReference"
          id: string
          title?: string | null
          permalink: string
          position: number
        }> | null
        addons?: Array<{
          __typename: "ProductPositionAddon"
          id: string
          variantKey: string
          parentProductType: string
        }> | null
        dimensioning?: {
          __typename: "ExternalDimensioningResult"
          transactionId: string
          environmentalVars?: Array<any> | null
          variantKeyData?: any
          dllVersion?: string | null
          language?: string | null
          technicalData?: Array<
            | {
                __typename: "ExternalDimensioningTechnicalDataDllVersion"
                dllVersion: string
              }
            | {
                __typename: "ExternalDimensioningTechnicalDataTable"
                header?: Array<string> | null
                content?: any
                summary?: string | null
                type?: string | null
              }
          > | null
          technicalInput?: Array<{
            __typename: "ExternalDimensioningTechnicalInput"
            name: string
            label?: string | null
            unit?: string | null
            value?: any
            userSelected: boolean
          }> | null
          supplementaryText?: Array<{
            __typename: "ExternalDimensioningSupplementaryText"
            text: string
          }> | null
          transferData?: {
            __typename: "ExternalDimensioningTransferData"
            origin?: string | null
          } | null
        } | null
      }> | null
    }> | null
  }
}

export type UpdateFloorMutationVariables = Exact<{
  id: string
  input: Types.UpdateFloorInput
}>

export type UpdateFloorMutation = {
  __typename: "Mutation"
  floor: {
    __typename: "Floor"
    id: string
    label?: string | null
    position: number
    createdAt: string
    updatedAt: string
    remark?: string | null
    hasClarificationRequest?: boolean | null
  }
}

export type DeleteFloorMutationVariables = Exact<{
  id: string
}>

export type DeleteFloorMutation = {
  __typename: "Mutation"
  floor: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateFloorDocument = gql`
  mutation CreateFloor(
    $input: CreateFloorInput!
    $parentType: String!
    $parentID: String!
  ) {
    floor: createFloor(
      input: $input
      parentType: $parentType
      parentID: $parentID
    )
      @rest(
        type: "Floor"
        method: "POST"
        endpoint: "floor"
        path: "/project-list/{args.parentType}/{args.parentID}/children"
        bodySerializer: "floor"
      ) {
      ...Floor
      ...FloorChildren
    }
  }
  ${FloorFragmentDoc}
  ${FloorChildrenFragmentDoc}
`
export type CreateFloorMutationFn = Apollo.MutationFunction<
  CreateFloorMutation,
  CreateFloorMutationVariables
>

/**
 * __useCreateFloorMutation__
 *
 * To run a mutation, you first call `useCreateFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFloorMutation, { data, loading, error }] = useCreateFloorMutation({
 *   variables: {
 *      input: // value for 'input'
 *      parentType: // value for 'parentType'
 *      parentID: // value for 'parentID'
 *   },
 * });
 */
export function useCreateFloorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFloorMutation,
    CreateFloorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFloorMutation, CreateFloorMutationVariables>(
    CreateFloorDocument,
    options
  )
}
export type CreateFloorMutationHookResult = ReturnType<
  typeof useCreateFloorMutation
>
export type CreateFloorMutationResult =
  Apollo.MutationResult<CreateFloorMutation>
export type CreateFloorMutationOptions = Apollo.BaseMutationOptions<
  CreateFloorMutation,
  CreateFloorMutationVariables
>
export const UpdateFloorDocument = gql`
  mutation UpdateFloor($id: ID!, $input: UpdateFloorInput!) {
    floor: updateFloor(id: $id, input: $input)
      @rest(
        type: "Floor"
        method: "PUT"
        endpoint: "floor"
        path: "/project-list/floors/{args.id}"
        bodySerializer: "floor"
      ) {
      ...Floor
    }
  }
  ${FloorFragmentDoc}
`
export type UpdateFloorMutationFn = Apollo.MutationFunction<
  UpdateFloorMutation,
  UpdateFloorMutationVariables
>

/**
 * __useUpdateFloorMutation__
 *
 * To run a mutation, you first call `useUpdateFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFloorMutation, { data, loading, error }] = useUpdateFloorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFloorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFloorMutation,
    UpdateFloorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateFloorMutation, UpdateFloorMutationVariables>(
    UpdateFloorDocument,
    options
  )
}
export type UpdateFloorMutationHookResult = ReturnType<
  typeof useUpdateFloorMutation
>
export type UpdateFloorMutationResult =
  Apollo.MutationResult<UpdateFloorMutation>
export type UpdateFloorMutationOptions = Apollo.BaseMutationOptions<
  UpdateFloorMutation,
  UpdateFloorMutationVariables
>
export const DeleteFloorDocument = gql`
  mutation DeleteFloor($id: ID!) {
    floor: deleteFloor(id: $id)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/floors/{args.id}?recursive=true"
      ) {
      success
    }
  }
`
export type DeleteFloorMutationFn = Apollo.MutationFunction<
  DeleteFloorMutation,
  DeleteFloorMutationVariables
>

/**
 * __useDeleteFloorMutation__
 *
 * To run a mutation, you first call `useDeleteFloorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFloorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFloorMutation, { data, loading, error }] = useDeleteFloorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFloorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFloorMutation,
    DeleteFloorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteFloorMutation, DeleteFloorMutationVariables>(
    DeleteFloorDocument,
    options
  )
}
export type DeleteFloorMutationHookResult = ReturnType<
  typeof useDeleteFloorMutation
>
export type DeleteFloorMutationResult =
  Apollo.MutationResult<DeleteFloorMutation>
export type DeleteFloorMutationOptions = Apollo.BaseMutationOptions<
  DeleteFloorMutation,
  DeleteFloorMutationVariables
>
